<template>
  <form-group :title="'Informações do agrupamento'">
    <v-row>
      <v-col cols="6">
        <input-text
          id="input:nomProdutoAgrupamento"
          v-model="payload.nomProdutoAgrupamento"
          :rules="[requiredRule]"
          label="Nome do agrupamento"
          required
        />
      </v-col>
      <v-col cols="6">
        <input-text
          id="input:descricao"
          v-model="payload.descricao"
          :rules="[requiredRule]"
          label="Descrição"
          required
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <input-text
          id="input:ordemExibicao"
          v-model="payload.ordemExibicao"
          :rules="[requiredRule]"
          label="Ordem de exibição"
          type="number"
          required
        />
      </v-col>
      <v-col
        v-if="editMode"
        cols="6"
      >
        <div
          v-if="preload"
          id="preload"
          :style="{ 'background-image': `url(${preload})` }"
        />
        <input-upload
          id="input:image"
          v-model="image"
          :max-size-in-mb="5"
          accept="image/jpeg, image/png"
          label="Imagem"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="editMode"
        cols="6"
      >
        <input-text
          id="input:id"
          v-model="payload.id"
          label="Código"
          disabled
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'ProdutoGroupContent',
  components: { FormGroup },
  mixins: [RulesMixin],
  props: {
    payload: {
      type: Object,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    preload: {
      type: [String, undefined],
      default() {
        return '';
      },
    },
    image: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style scoped>
#preload {
  width: 20rem;
  height: 15rem;
  border-radius: 1rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  margin-bottom: 1rem;
  object-fit: cover;
}
</style>
